import { render, staticRenderFns } from "./addEditddialog.vue?vue&type=template&id=b4cfceaa&scoped=true&"
import script from "./addEditddialog.vue?vue&type=script&lang=js&"
export * from "./addEditddialog.vue?vue&type=script&lang=js&"
import style0 from "./addEditddialog.vue?vue&type=style&index=0&id=b4cfceaa&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4cfceaa",
  null
  
)

export default component.exports